import { GraphQLEeseResponseOutput } from "../models/output/graphql-eese-response-output";
import { EeseRequirementDto } from "src/app/models/dto/eeseRequirementDto";

  export function convertGraphqlEeseRequirementToDto(input: GraphQLEeseResponseOutput): EeseRequirementDto {
    if(!input || !input.Id) return undefined;

    return {
      id: input.Id,
      name: input.Name,
      revision: input.Revision,
      variant: input.Variant,
      asil: input.Asil,
      cyberSecurity: input.CyberSecurity,
    }
  }
